module.exports = Promise.all([parcelRequire.load("7tSlc"), parcelRequire.load("gYf19"), parcelRequire.load("e5b67")]).then(() => parcelRequire('jsTsp'));